module.exports = __webpack_public_path__ + "src/assets/img/splash-screen.1f57de1f.gif";